import {
  BOTH_POSITION,
  BOTTOM_POSITION,
  LEFT_POSITION,
  RIGHT_POSITION,
  TOP_POSITION,
} from '../types/xy-chart.js';

type PositionType =
  | typeof BOTTOM_POSITION
  | typeof TOP_POSITION
  | typeof LEFT_POSITION
  | typeof RIGHT_POSITION
  | typeof BOTH_POSITION;

export function isXAxis(axis: { coordinate: 'x' | 'y' }) {
  return axis.coordinate === 'x';
}

export function isYAxis(axis: { coordinate: 'x' | 'y' }) {
  return axis.coordinate === 'y';
}

export function isBottomAxis(axis: { position: PositionType }) {
  return axis.position === BOTTOM_POSITION;
}

export function isTopAxis(axis: { position: PositionType }) {
  return axis.position === TOP_POSITION;
}

export function isLeftAxis(axis: { position: PositionType }) {
  return axis.position === LEFT_POSITION;
}

export function isRightAxis(axis: { position: PositionType }) {
  return axis.position === RIGHT_POSITION;
}

export function isBothAxis(axis: { position: PositionType }) {
  return axis.position === BOTH_POSITION;
}
